const { startMonitoring } = require('utils/monitoring')

exports.onClientEntry = () => {
  startMonitoring()
}
